// Creighton University's undergraduate majors (lane 2, #2745). Read on 2026-10-01 from
// the official Undergraduate Catalog (catalog.creighton.edu): the College of Arts and
// Sciences' list of majors by degree (tracks and specializations folded into their
// major), the Heider College of Business's list of BSBA majors, and the College of
// Nursing's BSN (the Traditional Curriculum for high school applicants). Accelerated
// bachelor's-to-master's and AAS-to-BS programs, minors and the ABSN for degree holders
// are left out. Ampersands are written as "and".
const majors = {
    "slug": "creighton-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Creighton's official Undergraduate Catalog, grouped by the college that offers it, with the degree. Tracks are folded into their major; minors and accelerated master's programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Creighton Undergraduate Catalog, College of Arts and Sciences",
                "url": "https://catalog.creighton.edu/undergraduate/arts-sciences/"
            },
            "majors": [
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Classical Languages",
                    "degree": "B.A."
                },
                {
                    "name": "Classical and Near Eastern Civilizations",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Cultural Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "B.A."
                },
                {
                    "name": "German Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Graphic Design and Film",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "International Relations",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Justice and Society",
                    "degree": "B.A."
                },
                {
                    "name": "Medical Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish and Hispanic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.A."
                },
                {
                    "name": "Sustainability",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Theology",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Applied Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Applied Physics and Pre-Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.S."
                },
                {
                    "name": "Exercise Science and Pre-Health Professions",
                    "degree": "B.S."
                },
                {
                    "name": "Health Administration and Policy",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S.Chm."
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "B.S.Evs."
                },
                {
                    "name": "Physics",
                    "degree": "B.S.Phy."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                }
            ]
        },
        {
            "name": "Heider College of Business",
            "source": {
                "label": "Creighton Undergraduate Catalog, Heider College of Business",
                "url": "https://catalog.creighton.edu/undergraduate/business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Business Intelligence and Analytics",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Finance and Technology",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Management",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "International Business",
                    "degree": "B.S.B.A."
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "Creighton Undergraduate Catalog, College of Nursing",
                "url": "https://catalog.creighton.edu/undergraduate/nursing/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                }
            ]
        }
    ]
};

export default majors;
